import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Icon } from 'antd';
import PlayerToken from './PlayerToken';
import '../../combinedStyles';

const Search = Input.Search;

class TrackedProspects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playerObjects: [],
      displayedPlayerArray: [],
      searchValue: '',
    };

    // this.generatePlayerObjectList();
  }

  componentWillMount() {
    this.setState({
      displayedPlayerArray: this.props.trackedPlayers,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      displayedPlayerArray: this.props.trackedPlayers,
    });
    if (nextProps.active == false) {
      this.setState({
        searchValue: '',
        displayedPlayerArray: [],
        numberOfPlayersToDisplay: 5,
      });
    }
  }

  playerRemoved(player) {
    var newplayerObjects = this.state.playerObjects;
    var index = newplayerObjects.findIndex((object) => {
      return object.id.S == player.id.S;
    });
    newplayerObjects.splice(index, 1);
    this.setState({
      playerObjects: newplayerObjects,
    });
    return;
  }

  handlesearchValueChange(event) {
    var newSearchValue = event.target.value;
    this.setState({
      searchValue: newSearchValue,
    });

    if (newSearchValue != '') {
      var displayedPlayerArray = [];
      var playerList = this.props.trackedPlayers;
      for (var i = 0; i < this.props.trackedPlayers.length; i++) {
        var player = playerList[i];
        if (player.name.toLowerCase().indexOf(newSearchValue.toLowerCase()) > -1) {
          displayedPlayerArray.push(player);
        }
      }
      this.setState({
        displayedPlayerArray: displayedPlayerArray,
      });
    } else {
      this.setState({
        displayedPlayerArray: this.props.trackedPlayers,
      });
    }
  }

  render() {
    var tokens = this.state.displayedPlayerArray.map((player, index) => {
      var tracked = true;
      var hidden = false;
      return (
        <div className='trackedTokenDiv' key={'trackDiv' + player.id}>
          <PlayerToken
            active={true}
            className='token'
            hidden={hidden}
            tracked={tracked}
            type={this.props.type}
            playerSelected={this.playerRemoved.bind(this, player)}
            search={false}
            icon='close'
            key={'track' + player.id}
            playerObj={player}></PlayerToken>
        </div>
      );
    });
    var pageType = this.props.type == 'trackedPlayers' ? 'tracked prospects' : 'hidden prospects';
    tokens =
      this.props.trackedPlayers.length > 0
        ? tokens
        : 'You have no ' + pageType + ', use search to add prospects to this page.';

    return (
      <div className='searchDiv'>
        <Search
          style={{ width: '50%' }}
          className='playerSearch'
          placeholder='Filter Players'
          onChange={this.handlesearchValueChange.bind(this)}
          value={this.state.searchValue}></Search>
        <div className='tokenDiv'>{tokens}</div>
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    allPlayers: storeState.lists.allPlayers,
    trackedPlayers: storeState.main.trackedPlayers,
    hiddenPlayers: storeState.main.hiddenPlayers,
    displayedUser: storeState.main.displayedUser,
  };
}

export default connect(mapStoreToProps)(TrackedProspects);



// WEBPACK FOOTER //
// ./src/components/trackedProspects/TrackedProspects.js